import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from "../../ui/tooltip";

const SVG_W = 70, SVG_H = 22, PAD = 2;

export function HealthScoreBadge({ health, history }) {
  if (!health || typeof health.score !== "number") return null;
  const { score, label, color, breakdown } = health;
  const b = breakdown || {};
  const points = (history || []).filter((h) => typeof h.score === "number");

  let trendSvg = null;
  if (points.length >= 2) {
    const values = points.map((p) => p.score);
    const min = 0, max = 100;
    const step = (SVG_W - PAD * 2) / (values.length - 1 || 1);
    const coords = values.map((v, i) => {
      const x = PAD + i * step;
      const y = SVG_H - PAD - ((v - min) / (max - min)) * (SVG_H - PAD * 2);
      return [x, y];
    });
    const pathD = coords.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
    const [lx, ly] = coords[coords.length - 1];
    trendSvg = (
      <svg width={SVG_W} height={SVG_H} viewBox={`0 0 ${SVG_W} ${SVG_H}`} className="flex-shrink-0" data-testid="inv-health-sparkline">
        <path d={pathD} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.9" />
        <circle cx={lx} cy={ly} r="2" fill={color} />
      </svg>
    );
  }

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className="flex items-center gap-2 rounded-full bg-card/70 dark:bg-white/10 backdrop-blur-sm border border-white/60 dark:border-white/10 px-2.5 py-1 cursor-help shadow-sm"
            data-testid="inv-insight-health-badge"
          >
            <div
              className="w-7 h-7 rounded-full flex items-center justify-center text-white text-[11px] font-bold leading-none"
              style={{ background: `linear-gradient(rgba(0,0,0,0.28), rgba(0,0,0,0.28)), ${color}` }}
            >
              {score}
            </div>
            <div className="flex flex-col leading-tight">
              <span className="text-[10px] uppercase tracking-wide text-muted-foreground">Salud</span>
              <span className="text-[11px] font-semibold" style={{ color }}>{label}</span>
            </div>
            {trendSvg && <div className="hidden sm:block border-l border-border/60 pl-2">{trendSvg}</div>}
          </div>
        </TooltipTrigger>
        <TooltipContent className="text-xs space-y-1 max-w-xs">
          <p className="font-semibold mb-1">Cómo se calcula tu nota</p>
          <div className="flex justify-between gap-6"><span>Mermas ({b.waste_ratio_pct ?? 0}%)</span><span className="tabular-nums">{b.waste_points ?? 0}/50</span></div>
          <div className="flex justify-between gap-6"><span>Días con recuento ({b.count_days ?? 0})</span><span className="tabular-nums">{b.count_points ?? 0}/30</span></div>
          <div className="flex justify-between gap-6"><span>Ingredientes con coste ({b.cost_coverage_pct ?? 0}%)</span><span className="tabular-nums">{b.cost_points ?? 0}/20</span></div>
          {points.length >= 2 && (
            <>
              <hr className="my-1 border-border/40" />
              <p className="text-[10px] text-muted-foreground">Evolución · últimos {points.length} meses</p>
              <div className="flex flex-wrap gap-1 mt-1">
                {points.map((p, i) => (
                  <span key={i} className="inline-flex items-center gap-1 text-[10px] font-mono tabular-nums">
                    <span className="text-muted-foreground">{p.month_key?.slice(5)}</span>
                    <span className="font-semibold" style={{ color: p.color || color }}>{p.score}</span>
                  </span>
                ))}
              </div>
            </>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
